import { Box, Typography } from '@mui/material';

import { useT } from '../i18n/LanguageContext';

type PartyBlockParty = {
  name: string;
  street: string;
  city: string;
  postalCode: string;
  country: string;
  registrationNumber: string | null;
  taxNumber: string | null;
  vatNumber: string | null;
};

/** A supplier or buyer as a document prints it. */
export const PartyBlock = ({ heading, party }: { heading: string; party: PartyBlockParty }) => {
  const t = useT();

  return (
    <Box>
      <Typography variant="overline" color="text.secondary">
        {heading}
      </Typography>
      <Typography sx={{ fontWeight: 560 }}>{party.name}</Typography>
      <Typography variant="body2">{party.street}</Typography>
      <Typography variant="body2">
        {party.postalCode} {party.city}, {party.country}
      </Typography>
      {party.registrationNumber ? (
        <Typography variant="body2" color="text.secondary">
          {t('field.registrationNumber')}: {party.registrationNumber}
        </Typography>
      ) : null}
      {party.taxNumber ? (
        <Typography variant="body2" color="text.secondary">
          {t('field.taxNumber')}: {party.taxNumber}
        </Typography>
      ) : null}
      {party.vatNumber ? (
        <Typography variant="body2" color="text.secondary">
          {t('field.vatNumber')}: {party.vatNumber}
        </Typography>
      ) : null}
    </Box>
  );
};
